import _ from 'lodash';
import { mapGetters } from 'vuex';
import loadGroupMixin from './loadGroupMixin';

export default {
  mixins: [
    loadGroupMixin,
  ],
  computed: {
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    ...mapGetters('plannedLoads', {
      loadingPlannedLoads: 'loadingLoads',
      plannedLoadsTime: 'timestamp',
      planningLoadGroups: 'list',
      storeLoadGroupsCompanyId: 'companyId',
    }),
    planningLoadGroupUnassignedLoads() {
      return this.planningLoadGroups.filter(load => this.planningLoadGroupAvailableTruckCount(load) > 0)
        .map((load) => {
          // eslint-disable-next-line no-param-reassign
          // load.loadGroup = this.sponsorLoadGroup(load.loadGroup)
          load.loadGroup.details.sponsor = load.loadGroup.details.customerCompany || load.loadGroup.details.listingCompany;
        return load;
      });
    },
    planningLoadGroupUnassignedTruckCount() {
      return _.sumBy(this.planningLoadGroupUnassignedLoads, l => this.planningLoadGroupAvailableTruckCount(l));
    },
  },
  methods: {
    planningLoadGroupAvailableTruckCount(load) {
      const loadGroup = load.loadGroup || load;
      return loadGroup.availableLoadCount;
    },
    planningLoadGroupActiveBookedTruckCount(load) {
      const booked = _.get(load, 'bookedLoads', []);
      return _.filter(booked, b => !this.__isBookedLoadCanceled(b)).length;
    },
    planningLoadGroupAvailableLoadAssignmentRangeOptions(load) {
      return _.range(1, this.planningLoadGroupAvailableTruckCount(load) + 1).map((i) => {
        return { value: i, text: i };
      });
    },

    reloadCompanyPlanningLoadGroups(companyId) {
      this.$store.dispatch('plannedLoads/getPlannedLoads', companyId);
    },
    replacePlanningLoad(load) {
      this.$store.dispatch('plannedLoads/updateLoad', load);
    },
    __isBookedLoadCanceled(booked) {
      return booked.loadStatus === 'CANCELED';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/planningLoadGroupsMixin.js